import * as S from './styles';

import { ReactComponent as Profile } from '#assets/svg/profile_icon.svg';
import { ReactComponent as User } from '#assets/svg/user_icon.svg';
import { ReactComponent as Port } from '#assets/svg/portfolio_icon.svg';
import { ReactComponent as Authenticate } from '#assets/svg/authenticate_icon.svg';

import MyProfile from '#assets/images/section_my_profile.png';
import CreateProfile from '#assets/images/section_create_profile.png';
import Seo from '#assets/images/section_seo.png';
import RevealPlatform from '#assets/images/section_reveal_platform.png';

import Calender from '#assets/images/section_calender.png';
import Verify from '#assets/images/section_verify.png';
import Chart from '#assets/images/section_chart.png';
import Kakao from '#assets/images/section_kakao.png';

import PhoneGroup from '#assets/images/phone_group.png';
import Portfolio from '#assets/images/section_portfolio.png';

import Expert from '#assets/images/section_expert.png';
import Certificate from '#assets/images/section_certificate.png';

import { ReactNode } from 'react';

const Wrap = ({
  children,
  className
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div className={`${className} w-full bg-[#1F1E25] rounded-[2.4rem]`}>
      {children}
    </div>
  );
};

export const LandingSection = () => {
  return (
    <S.Container>
      <article className="w-full max-w-[107rem] flex flex-col gap-[2rem] justify-center max-[1024px]:w-[90%]">
        <section className="flex flex-col items-center justify-center gap-[2rem]">
          <Profile />
          <p className="text-[#8E899F] text-[2.4rem] font-bold max-[1024px]:text-[1.8rem]">
            프로필
          </p>
        </section>
        <section className="text-center">
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            나만의 프로필을 만들고
          </p>
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            신규 고객을 창출해 보세요
          </p>
        </section>
        <section className="text-center pb-[4rem]">
          <p className="text-[#746D87] text-[2.4rem] max-[1024px]:text-[1.8rem]">
            나만의 프로필 페이지를 생성하고
          </p>
          <p className="text-[#746D87] text-[2.4rem] max-[1024px]:text-[1.8rem]">
            내가 원하는 주소를 설정하여 인스타그램에 공유할 수 있습니다
          </p>
        </section>

        <section>
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0 max-[1024px]:items-center">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem]">
                나만의 프로필
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                나만의 프로필 페이지을 생성하고,
                <br />
                내가 원하는 주소를 설정하여
                <br />
                인스타그램에 공유할 수 있습니다.
              </p>
            </div>
            <img
              src={MyProfile}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover max-[1024px]:mx-auto"
            />
          </Wrap>
        </section>

        <section className="grid grid-cols-2 gap-[2rem] max-[1024px]:flex flex-col">
          <Wrap className="max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem] max-[1024px]:text-center">
                피벗 플랫폼 노출
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                검증된 트레이너 매칭 플랫폼 <span>피벗</span>을 통해
                <br />내 주변 고객들에게 노출됩니다.
              </p>
            </div>
            <img
              src={RevealPlatform}
              className="!w-[80%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
          <Wrap className="max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem] max-[1024px]:text-center">
                구글, 네이버 노출
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                SEO를 통해 구글과 네이버에
                <br />내 프로필이 상단 노출됩니다.
              </p>
            </div>
            <img
              src={Seo}
              className="!w-[80%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
        </section>

        <section>
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem] max-[1024px]:text-center">
                프로필 이미지 생성
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                피벗에 프로필을 작성하면
                <br />
                자동으로 프로필 이미지가 생성됩니다.
              </p>
            </div>
            <img
              src={CreateProfile}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover max-[1024px]:mx-auto"
            />
          </Wrap>
        </section>
      </article>

      <article className="w-full max-w-[107rem] flex flex-col gap-[2rem] justify-center max-[1024px]:w-[90%]">
        <section className="flex flex-col items-center justify-center gap-[2rem]">
          <User />
          <p className="text-[#8E899F] text-[2.4rem] font-bold max-[1024px]:text-[1.8rem]">
            회원 관리
          </p>
        </section>
        <section className="text-center pb-[4rem]">
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            체계적인 회원 관리를 통한
          </p>
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            회원 만족도와 재등록률 상승
          </p>
        </section>

        <section className="grid grid-cols-2 gap-[2rem] max-[1024px]:flex max-[1024px]:flex-col">
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem] max-[1024px]:text-center">
                일정 관리
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                수업 일정과 개인 일정을 한 곳에서 관리하고,
                <br />
                남은 수업 회차를 한 눈에 확인할 수 있습니다.
              </p>
            </div>
            <img
              src={Calender}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem] max-[1024px]:text-center">
                운동 차트
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                운동 사진, 영상, 피드백이 담긴 운동 차트를 통해
                <br />
                변화하고 성장하는 모습을 회원이 확인할 수 있습니다.
              </p>
            </div>
            <img
              src={Chart}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
        </section>

        <section className="grid grid-cols-2 gap-[2rem] max-[1024px]:flex max-[1024px]:flex-col">
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem] max-[1024px]:text-center">
                오운완 인증 공유
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                회원은 본인의 운동 차트를 인스타그램에 공유하고
                <br />
                PT와 체계적인 관리를 인증할 수 있습니다.
              </p>
            </div>
            <img
              src={Verify}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem] max-[1024px]:text-center">
                알림톡 발송
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                내일 수업 일정과 오늘 수업 내용에 대한
                <br />
                알림톡이 회원에게 자동으로 발송됩니다.
              </p>
            </div>
            <img
              src={Kakao}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
        </section>
      </article>

      <article className="w-full max-w-[107rem] flex flex-col gap-[2rem] justify-center max-[1024px]:w-[90%]">
        <section className="flex flex-col items-center justify-center gap-[2rem]">
          <Port />
          <p className="text-[#8E899F] text-[2.4rem] font-bold max-[1024px]:text-[1.8rem]">
            트레이닝 성과
          </p>
        </section>

        <section className="text-center pb-[4rem]">
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            나의 경험과 노하우를
          </p>
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            가장 잘 드러내는 방법
          </p>
        </section>

        <section>
          <Wrap className="flex flex-col justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0 max-[1024px]:items-center">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem]">
                트레이닝 성과 자동 완성
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                회원 관리 데이터를 바탕으로 나만의 트레이닝 성과를 쉽고 빠르게
                만들 수 있습니다.
              </p>
            </div>
            <div className="flex justify-center pt-[6rem] max-[1024px]:relative max-[1024px]:pt-[2rem]">
              <img src={PhoneGroup} className="z-2" />
            </div>
          </Wrap>
        </section>

        <section>
          <Wrap className="flex flex-col justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0 max-[1024px]:items-center">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem]">
                분야별 트레이닝 성과
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                다이어트, 체형교정, 재활 등 분야별 트레이닝 성과를
                <br />
                체계적으로 정리하고 노출할 수 있습니다.
              </p>
            </div>
            <div className="w-full py-[8rem] overflow-hidden">
              <img src={Portfolio} className="mx-auto object-cover" />
            </div>
          </Wrap>
        </section>
      </article>

      <article className="w-full max-w-[107rem] flex flex-col gap-[2rem] justify-center max-[1024px]:w-[90%]">
        <section className="flex flex-col items-center justify-center gap-[2rem]">
          <Authenticate />
          <p className="text-[#8E899F] text-[2.4rem] font-bold max-[1024px]:text-[1.8rem]">
            피벗 전문가 인증
          </p>
        </section>
        <section className="text-center pb-[4rem]">
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            나의 전문성을
          </p>
          <p className="text-[4rem] font-bold max-[1024px]:text-[3.4rem]">
            증명하는 방법
          </p>
        </section>

        <section>
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0 max-[1024px]:items-center">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem]">
                분야별 전문가 인증
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                고객 만족, 회원 관리, 운동 지식 전문가 인증과
                <br />
                다이어트, 체형교정, 재활 등 분야별 전문가 인증을 통해
                <br />
                나의 전문성을 증명할 수 있습니다.
              </p>
            </div>
            <img
              src={Expert}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
        </section>

        <section>
          <Wrap className="flex justify-between max-[1024px]:block max-[1024px]:p-[2rem] max-[1024px]:pb-0">
            <div className="flex flex-col gap-[2.4rem] pl-[5.6rem] pt-[6rem] max-[1024px]:p-0 max-[1024px]:items-center">
              <h1 className="font-bold text-[2.8rem] max-[1024px]:text-[2.4rem]">
                학력, 경력, 자격 인증
              </h1>
              <p className="text-[#8E899F] text-[1.8rem] leading-24 max-[1024px]:text-center max-[1024px]:text-[1.6rem]">
                체육 관련 전공 학사/석사/박사
              </p>
            </div>
            <img
              src={Certificate}
              className="!w-[50%] max-[1024px]:!w-[80%] object-cover mx-auto"
            />
          </Wrap>
        </section>
      </article>

      <article className="w-full max-w-[107rem] flex flex-col gap-[2rem] justify-center max-[1024px]:w-[90%] -z-1">
        <section className="text-center z-1">
          <p className="text-[4rem] font-bold max-[1024px]:text-[2.4rem]">
            이런 고민을 하고 있다면,
          </p>
          <p className="text-[4rem] font-bold max-[1024px]:text-[2.4rem]">
            지금 바로 피벗을 시작하세요.
          </p>
        </section>
        {/* <img
          src={Highlight}
          className="absolute w-full -translate-x-1/2 left-1/2 top-[-40rem]"
        /> */}
      </article>
    </S.Container>
  );
};
